export const SHAPE = {
  SIZE: { LARGE: "large", MEDIUM: "medium", SMALL: "small" },
  SHAPE: { ROUND: "round", CIRCLE: "circle" },
};